import http from '@/utils/http';

export const getNewsList = (
  params: Partial<API.News.NewsListParams>,
): Promise<API.News.NewsListResult> => http.get('/news', { params });

export const createNews = (data: API.News.NewsItem) => http.post('/news', data);

export const updateNews = (id: number, data: Partial<API.News.NewsItem>) =>
  http.patch(`/news/${id}`, data);

export const updateNewsShow = (id: number, isShow: 0 | 1) =>
  http.patch(`/news/${id}/show`, { isShow });

export const updateNewsRecommend = (id: number, isRecommend: 0 | 1) =>
  http.patch(`/news/${id}/recommend`, { isRecommend });

export const deleteNews = (id: number) => http.delete(`/news/${id}`);

export const getNews = (id: number) =>
  http.get<API.News.NewsItem>(`/news/${id}`);
